import { useLayoutEffect, useRef, useState } from 'react';

import RenderRichText from '@/components/RenderRichText';
import { ShowMoreButton } from '@/ui';

interface Props {
  notes: string;
}

const VerificationNotes = ({ notes }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const notesRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const element = notesRef.current;
    if (!element) return;

    const measure = () => {
      if (isExpanded) return;

      setIsOverflowing(element.scrollHeight > element.clientHeight);
    };

    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);

    return () => observer.disconnect();
  }, [notes, isExpanded]);

  return (
    <div className="flex w-full flex-col gap-1 text-sm">
      <span className="text-uniform-gray-500">Notes</span>
      <div
        ref={notesRef}
        data-testid="verification-notes"
        className={isExpanded ? 'max-h-60 overflow-y-auto pr-1' : 'line-clamp-2'}>
        <RenderRichText className="prose-sm" body={notes} />
      </div>
      {(isOverflowing || isExpanded) && (
        <ShowMoreButton
          className="self-start"
          isExpanded={isExpanded}
          onToggle={() => setIsExpanded((expanded) => !expanded)}
        />
      )}
    </div>
  );
};

export default VerificationNotes;
